export const TrackMenu = [{
  id: 'TrackDashboard',
  name: 'Dashboard',
  permission: 'view_track_dashboard',
},
{
  id: 'Trips',
  name: 'Trips',
  permission: 'view_trips',
},
{
  id: 'Map View',
  name: 'Map View',
  permission: 'view_map',
},
{
  id: 'Rejections',
  name: 'Rejections',
  permission: 'view_rejections',
}];

export const filters = {
  DATE: 'Date',
  TRANSPORTER: 'MDM_TRANSPORTER',
  STATUS: 'Status',
  TRACKTYPE: 'Track Type',
  AUTOCOMPLETEREASON: 'Auto Complete Reason',
};

export const tripCountHeaders = [
  { id: 0, title: 'Total Trips', column: 'totalTrips', iconName: 'icon-location', colSpan: 6, routerActive: true },
  { id: 1, title: 'Pending', column: 'pending', valueClass: 'text-orange', iconName: 'icon-sla', colSpan: 6, routerActive: true, routerValue: 'PENDING' },
  { id: 2, title: 'Active', column: 'active', valueClass: 'text-yellow-light', iconName: 'icon-vehicle', colSpan: 6, routerActive: true, routerValue: 'STARTED' },
  { id: 3, title: 'Invalid', column: 'invalid', valueClass: 'text-red', iconName: 'icon-risk', colSpan: 6, routerActive: true, routerValue: 'INVALID' },
  { id: 4, title: 'Completed', column: 'delivered', valueClass: 'text-green-light', iconName: 'icon-tick', class: 'border-0', colSpan: 8, routerActive: true, routerValue: 'COMPLETED' },
  { id: 5, title: 'Cancelled', column: 'cancelled', valueClass: 'text-red', iconName: 'icon-cancelled', colSpan: 8, routerActive: true, routerValue: 'CANCELLED' },
  { id: 6, title: 'Auto Completed', column: 'notTracking', valueClass: 'text-grey', iconName: 'icon-risk', colSpan: 8, routerActive: true, routerValue: 'NOT TRACKING' },
];

export const pickupHeaders = [
  { id: 0, title: 'Not Reached', description: 'Loading', column: 'pickupNotReached', iconName: 'icon-material', routerActive: true, routerValue: 'pickupNotReached' },
  // { id: 0, title: 'Breached', column: 'notReached' },
  { id: 1, title: 'SLA Breached', description: 'ETA missed', column: 'slaBreachedPickupCount', valueClass: 'text-red', class: 'border-0', iconName: 'icon-sla', routerActive: true, routerValue: 'slaBreachedPickupCount' },
  { id: 2, title: 'At Risk', description: 'ETA Delay', column: 'pickupAtRisk', class: 'border-0', valueClass: 'text-orange', iconName: 'icon-risk', routerActive: true, routerValue: 'pickupAtRisk' },
  { id: 3, title: 'Reached', description: 'Loading', column: 'pickupReached', iconName: 'icon-reached', routerActive: true, routerValue: 'pickupReached' },
];

export const dropOffHeaders = [
  // { id: 0, title: 'Breached', column: 'dispatched' },
  { id: 0, title: 'Reached', description: 'Unloading', column: 'dropReached', valueClass: 'text-blue-dark', class: 'border-0', iconName: 'icon-dispatch', routerActive: true, routerValue: 'dropReached' },
  { id: 1, title: 'SLA Breached', description: 'ETA missed', column: 'slaBreachedDropCount', valueClass: 'text-red', class: 'border-0', iconName: 'icon-sla', routerActive: true, routerValue: 'slaBreachedDropCount' },
  { id: 2, title: 'At Risk', description: 'ETA Delay', column: 'dropAtRisk', valueClass: 'text-orange', class: 'border-0', iconName: 'icon-risk', routerActive: true, routerValue: 'dropAtRisk' },
];

export const inTransitHeaders = [
  { id: 0, title: 'Not Reached', description: 'Unloading', column: 'inTransit', iconName: 'icon-intransit', routerActive: true, routerValue: 'inTransit' },
];

export const etaDetailsHeaders = [
  { id: 0, title: 'Early', description: 'Before 12 hrs', column: 'early', valueClass: 'text-green-light' },
  { id: 1, title: 'On time', description: '+/- 2 Hrs', column: 'onTime', valueClass: 'text-blue-dark' },
  { id: 2, title: 'Late', description: 'More than 12 Hrs', column: 'late', valueClass: 'text-orange', class: 'border-0' },
  { id: 3, title: 'Very Late', description: 'More than 24 hrs', column: 'veryLate', valueClass: 'text-red' },
];

export const unloadingVsEtaHeaders = [
  { id: 0, title: 'Reached & Released', description: 'Total Dropoffs', column1: 'countForTotalReportAndRelease', column2: 'count', iconName: 'icon-intransit', colSpan: 5, routerActive: true, routeCategory: 'widgetFilter', type: 'report_release', routerValue: 'unloading_vs_eta' },
  { id: 1, title: '< 24 Hrs', description: 'Unloading Detention', column1: 'unloadingVsEtaNotReleaseVariance', column2: 'lessThanOneDay', valueClass: 'text-green-light', colSpan: 4, routerActive: true, routeCategory: 'widgetFilter', type: 'less_than_a_day', routerValue: 'unloading_vs_eta' },
  { id: 2, title: '24 Hrs to 48 Hrs', description: 'Unloading Detention', column1: 'unloadingVsEtaNotReleaseVariance', column2: 'oneToTwoDays', valueClass: 'text-blue-dark', class: 'border-0', colSpan: 5, routerActive: true, routeCategory: 'widgetFilter', type: 'one_day_to_two_days', routerValue: 'unloading_vs_eta' },
  { id: 3, title: '48 Hrs to 72 Hrs', description: 'Unloading Detention', column1: 'unloadingVsEtaNotReleaseVariance', column2: 'twoToThreeDays', valueClass: 'text-orange', class: 'border-0', colSpan: 5, routerActive: true, routeCategory: 'widgetFilter', type: 'two_days_to_three_days', routerValue: 'unloading_vs_eta' },
  { id: 4, title: '> 72 Hrs', description: 'Unloading Detention', column1: 'unloadingVsEtaNotReleaseVariance', column2: 'threeDaysMore', valueClass: 'text-red', class: 'border-0', colSpan: 5, routeCategory: 'widgetFilter', type: 'above_three_days', routerValue: 'unloading_vs_eta', routerActive: true },
];

export const trackingHeaders = [
  { id: 0, title: 'Sim', column: 'sim', iconName: 'icon-sim', routerActive: true, routerValue: 'SIM', routeCategory: 'trackType' },
  { id: 1, title: 'Tracked', column: 'tracked', class: 'border-0', routerActive: true, routerValue: 'tracked', routerParent: { trackType: 'SIM' }, routeCategory: 'dashboardFilter' },
  { id: 2, title: 'No Location Available', column: 'nontrackable', class: 'border-0', valueClass: 'text-red', routerActive: true, routerValue: 'nontrackable', routerParent: { trackType: 'SIM' }, routeCategory: 'dashboardFilter' },
  { id: 3, title: 'No Pings', column: 'simNoPings', class: 'border-0', valueClass: 'text-red', routerActive: true, routerValue: 'noPings', routerParent: { trackType: 'SIM' }, routeCategory: 'dashboardFilter' },
  { id: 4, title: 'App', column: 'app', iconName: 'icon-smartphone', routerActive: true, routerValue: 'APP', routeCategory: 'trackType' },
  { id: 5, title: 'No Pings', column: 'appNoPings', class: 'border-0', valueClass: 'text-red', routerActive: true, routerValue: 'noPings', routerParent: { trackType: 'APP' }, routeCategory: 'dashboardFilter' },
  { id: 6, title: 'GPS', column: 'gps', iconName: 'icon-gps', routerActive: true, routerValue: 'GPS', routeCategory: 'trackType' },
  { id: 7, title: 'No Pings', column: 'gpsNoPings', class: 'border-0', valueClass: 'text-red', routerActive: true, routerValue: 'noPings', routerParent: { trackType: 'GPS' }, routeCategory: 'dashboardFilter' },
];

export const etaBarChartConstants = {
  bars: [
    { id: 0, class: 'l-1 chart-bg-green', label: 'Early', labelColumn: 'early' },
    { id: 1, class: 'l-2 chart-bg-blue', label: 'On Time', labelColumn: 'onTime' },
    { id: 2, class: 'l-3 chart-bg-orange', label: 'Late', labelColumn: 'late' },
    { id: 3, class: 'l-4 chart-bg-red', label: 'Very Late', labelColumn: 'veryLate' },
  ],
};

export const autoCompleteBarChartConstants = {
  bars: [
    { id: 0, class: 'l-1 chart-bg-blue', label: 'Consent N/a', labelColumn: 'consent_not_available' },
    { id: 1, class: 'l-2 chart-bg-orange', label: 'Location N/a', labelColumn: 'location_not_available' },
    { id: 2, class: 'l-3 chart-bg-green', label: 'Partial Location', labelColumn: 'partial_location', multiLineClass: 'multi-line' },
    { id: 3, class: 'l-4 chart-bg-red', label: 'Partial Geofence', labelColumn: 'partial_geo_fence' },
    { id: 4, class: 'l-5 chart-bg-green', label: 'AutoComplete Days Reached', labelColumn: 'auto_complete' },
  ],
};

export const tripHaltBarChartConstants = {
  bars: [
    { id: 0, class: 'l-1 chart-bg-blue' },
    { id: 1, class: 'l-2 chart-bg-orange' },
    { id: 2, class: 'l-3 chart-bg-green' },
    { id: 3, class: 'l-4 chart-bg-red' },
    { id: 4, class: 'l-5 chart-bg-green' },
  ],
};

export const getDetailsApiConstants = [
  { id: 0, resultObj: 'tripCount', loadingObj: 'isTripCountLoading', section: 'tripCount' },
  { id: 1, resultObj: 'dashboardConfigs', loadingObj: 'isdashboardConfigsLoading', section: 'dashboardConfigs' },
  { id: 2, resultObj: 'trackDetailsArray', loadingObj: 'isTrackingLoading', section: 'trackingDetails' },
  { id: 3, resultObj: 'etaCompliance', loadingObj: 'isEtaComplianceLoading', section: 'etaCompliance' },
  { id: 4, resultObj: 'autoCompleteTripCount', loadingObj: 'isautoCompleteTripCountLoading', section: 'autoCompleteTripCount' },
  { id: 5, resultObj: 'shortHaulDeliveryVsEta', loadingObj: 'isShortHaulDeliveryVsEtaLoading', section: 'shortHaulDeliveryVsEta' },
  { id: 6, resultObj: 'longHaulDeliveryVsEta', loadingObj: 'isLongHaulDeliveryVsEtaLoading', section: 'longHaulDeliveryVsEta' },
  { id: 7, resultObj: 'unloadingVsEtaNotReleaseVariance', loadingObj: 'isUnloadingVsEtaNotReleaseVarianceLoading', section: 'unloadingVsEtaNotReleaseVariance' },
  { id: 8, resultObj: 'countForTotalReportAndRelease', loadingObj: 'isCountForTotalReportAndReleaseLoading', section: 'countForTotalReportAndRelease' },
  { id: 9, resultObj: 'tripHaltDuration', loadingObj: 'isTripHaltDurationLoading', section: 'tripHaltDuration' },
];

export const trackListConstant = [
  { id: 0, title: 'ETA', colSpan: 3, column: 'actualEta', subDetail: { column: 'etaDetail' }, showAlert: true },
  { id: 1, title: 'Shipment Id', colSpan: 3, column: 'shipmentNumber', truncate: 20, subDetail: { column: 'createdAt' } },
  { id: 2, title: 'Status', colSpan: 3, column: 'status' },
  { id: 3, title: 'Source', colSpan: 3, column: 'source', truncate: 17, subDetail: { column: 'sourceAddress', class: 'text-xs', truncate: 50 } },
  { id: 4, title: 'Destination', colSpan: 3, column: 'destination', truncate: 17, subDetail: { column: 'destinationAddress', class: 'text-xs', truncate: 50 } },
  { id: 5, title: 'Transporter', colSpan: 3, column: 'transporterName', truncate: 25 },
  { id: 6, title: 'Last Known', colSpan: 3, column: 'lastKnownPlace', subDetail: { column: 'lastKnownTime' } },
];

export const rejectListConstant = [
  { id: 0, title: 'Shipment Id', colSpan: 4, column: 'shipmentNumber', truncate: 20, subDetail: { column: 'createdAt' } },
  { id: 1, title: 'Phone Number', colSpan: 4, column: 'driverPhoneNumber' },
  { id: 2, title: 'Vehicle Number', colSpan: 4, column: 'vehicleNumber' },
];

export const trackStatus = [
  { id: -1, name: 'ALL STATUS' },
  { id: 1, name: 'STARTED', colorName: 'status-pink', value: 'STARTED' },
  { id: 2, name: 'PENDING', colorName: 'status-orange', value: 'PENDING' },
  { id: 3, name: 'COMPLETED', colorName: 'status-green', value: 'COMPLETED', excludeEta: true },
  { id: 4, name: 'CANCELLED', colorName: 'status-red', value: 'CANCELLED', excludeEta: true },
  { id: 5, name: 'INVALID', colorName: 'status-red', value: 'INVALID', excludeEta: true },
  { id: 6, name: 'AUTO COMPLETED', colorName: 'status-lightgrey', value: 'AUTO COMPLETED', excludeEta: true },
];

export const trackType = [
  { id: -1, name: 'ALL TRACKING TYPES' },
  { id: 1, name: 'SIM', iconName: 'icon-simcard', value: 'SIM' },
  { id: 2, name: 'APP', iconName: 'icon-mobile', value: 'APP' },
  { id: 3, name: 'GPS', iconName: 'icon-transit', value: 'GPS' },
  { id: 4, name: 'HYPERTRACK', iconName: 'icon-smartphone', value: 'HYPERTRACK' },
];

export const autoCompleteReason = [
  { id: -1, name: 'All AutoComplete Reasons' },
  { id: 1, name: 'Consent N/A', colorName: 'status-red', value: 'CONSENT NA' },
  { id: 2, name: 'Location N/A', colorName: 'status-red', value: 'LOCATION NA' },
  { id: 3, name: 'Partial Location', colorName: 'status-red', value: 'PARTIAL LOCATION' },
  { id: 4, name: 'Partial Geofence', colorName: 'status-red', value: 'PARTIAL GEOFENCE' },
  { id: 5, name: 'Auto complete days reached', colorName: 'status-red', value: 'AUTO COMPLETED' },
];

export const pickDropOffConstants = [
  { id: 0, label: 'stopType', title: 'Stops', width: 150 },
  { id: 1, label: 'location', title: 'Location', width: 260 },
  { id: 2, label: 'distanceRemained', title: 'Distance to Travel', width: 150 },
  { id: 3, label: 'plannedArrival', title: 'Planned Arrival', width: 250 },
  { id: 4, label: 'estimatedArrival', title: 'Estimated Arrival' },
];

export const materialConstants = [
  { id: 0, label: 'code', title: 'Material', width: 150 },
  { id: 1, label: 'quantity', title: 'Billed Quantity', width: 150 },
  { id: 2, label: 'weight', title: 'Weight', width: 150 },
  { id: 3, label: 'volume', title: 'Volume', width: 150 },
  { id: 4, label: 'reference_id', title: 'Reference Id' },

];

export const timelineConstants = [
  { id: 0, label: 'date', title: 'Ping Received', width: 220 },
  { id: 1, label: 'location', title: 'Location' },
];

export const trackDetailsConstant = [
  { id: 0, title: 'Actual ETA', column: 'actualEta', subDetail: { column: 'etaDetail', class: 'text-xs timing', truncate: 50 } },
  { id: 1, title: 'Planned ETA', column: 'eta' },
  { id: 2, title: 'Created Date', column: 'createdAt' },
  { id: 3, title: 'Transporter', column: 'transporterName' },
  { id: 4, title: 'Vehicle Number', column: 'truckNumber', subDetail: { column: 'isGpsEnabled', class: 'text-xs text-green', truncate: 50 } },
  { id: 5, title: 'Driver Name', column: 'driverName' },
  { id: 6, title: 'Driver Phone Number', column: 'driverNumber' },
  { id: 7, title: 'Source', column: 'source', subDetail: { column: 'sourceAddress', class: 'text-xs', truncate: 50 } },
  { id: 8, title: 'Destination', column: 'destination', subDetail: { column: 'destinationAddress', class: 'text-xs', truncate: 50 } },
  { id: 9, title: 'Last Known Location', column: 'lastKnownPlace', subDetail: { column: 'lastKnownTime' } },
];

export const searchParameters = [
  {
    id: 1,
    name: 'source',
    query: 'source',
    multiSearch: 'source',
    multiDropDownQueryOptions: [
      {
        label: 'in Ref id',
        tlabel: 'INDENT_IN_REF_ID',
        typeLabel: 'Ref id',
        ttypeLabel: 'INDENT_REF_ID',
        name: 'Source Ref id',
        tname: 'EXCEPTION_SOURCE_REF_ID',
        query: 'sourceRefIds',
      },
      {
        label: 'in Name',
        tlabel: 'INDENT_IN_NAME',
        typeLabel: 'Name',
        ttypeLabel: 'INDENT_NAME',
        name: 'Source Name',
        tname: 'EXCEPTION_SOURCE_NAME',
        query: 'sourceNames',
      },
    ],
  },
  {
    id: 2,
    name: 'destination',
    query: 'destination',
    multiSearch: 'destination',
    multiDropDownQueryOptions: [
      {
        label: 'in Ref id',
        tlabel: 'INDENT_IN_REF_ID',
        typeLabel: 'Ref id',
        ttypeLabel: 'INDENT_REF_ID',
        name: 'Destination Ref id',
        tname: 'INDENT_DESTINATION_REF_ID',
        query: 'destinationRefIds',
      },
      {
        label: 'in Name',
        tlabel: 'INDENT_IN_NAME',
        typeLabel: 'Name',
        ttypeLabel: 'INDENT_NAME',
        name: 'Destination Name',
        tname: 'INDENT_DESTINATION_NAME',
        query: 'destinationNames',
      },
    ],
  },
  {
    id: 3,
    name: 'transporter',
    query: 'transporter',
  },
  {
    id: 4,
    name: 'shipment number',
    query: 'shipmentId',
  },
  {
    id: 5,
    name: 'vehicle number',
    query: 'vehicleNumber',
  },
  {
    id: 6,
    name: 'Phone number',
    query: 'phoneNumber',
  },
];

export const rejectsearchParameters = [
  {
    id: 1,
    name: 'shipment number',
    query: 'shipmentId',
  },
];

export const transError = {
  MISSING_ID: 'Missing transporterId/carrierId',
  MISSING_NAME: 'Missing transporterName',
};

export const endTripMessage = [
  { id: 1, message: 'Destination Reached', show: false },
  { id: 2, message: 'Auto completed', show: true },
  { id: 3, message: 'Trip status set to NOT TRACKING due to creation of new trip using the same mobile number or vehicle number. Shipment ID of new trip: #customerReference#', show: true },
  { id: 4, message: 'Indent marked as delivered', show: true },
  { id: 5, message: 'Trip Manually Ended', show: true },
];

export const buttonList = [
  {
    id: 1,
    name: 'Export',
    show: true,
    class: 'header_sbtn',
    disabled: false,
    emitMethod: 'export',
  },
];

export const dashboardSearchParameters = [
  {
    id: 1,
    name: 'material code',
    query: 'material_code',
    placeholder: 'Type Material Code',
    dynamicDropDown: true,
    eventEmitter: 'mdmV2/getMaterialCodeList',
  },
  {
    id: 2,
    name: 'material category',
    query: 'material_category',
    placeholder: 'Type Material Category',
    dynamicDropDown: true,
    eventEmitter: 'mdmV2/getMaterialCategoryList',
  },
  {
    id: 3,
    name: 'material brand',
    query: 'brand',
    placeholder: 'Type Material Brand',
    dynamicDropDown: true,
    eventEmitter: 'mdmV2/getMaterialBrandList',
  },
  {
    id: 4,
    name: 'material sub-brand',
    query: 'sub_brand',
    placeholder: 'Type Material Sub-brand',
    dynamicDropDown: true,
    eventEmitter: 'mdmV2/getMaterialSubBrandList',
  },
  {
    id: 5,
    name: 'source name',
    query: 'source_name',
    placeholder: 'Type Source',
    dynamicDropDown: true,
    eventEmitter: 'mdmV2/getSourceDestinationList',
    dropDownCategory: [
      {
        id: 1,
        label: 'Depot',
      },
      {
        id: 2,
        label: 'Consignee',
      },
    ],
  },
  {
    id: 6,
    name: 'destination name',
    query: 'destination_name',
    placeholder: 'Type Destination',
    dynamicDropDown: true,
    eventEmitter: 'mdmV2/getSourceDestinationList',
    dropDownCategory: [
      {
        id: 1,
        label: 'Depot',
      },
      {
        id: 2,
        label: 'Consignee',
      },
    ],
  },
  {
    id: 7,
    name: 'vehicle number',
    query: 'vehicle_number',
  },
];


export const deliveryVsEtaLongHaul = [
  { id: 0, title: 'Early', column: 'early', valueClass: 'text-green-light', routeCategory: 'widgetFilter', type: 'early', routerValue: 'long_haul', routerActive: true },
  { id: 1, title: 'On time', column: 'onTime', valueClass: 'text-blue-dark', routeCategory: 'widgetFilter', type: 'on_time', routerValue: 'long_haul', routerActive: true },
  { id: 2, title: 'Late', column: 'late', valueClass: 'text-orange', class: 'border-0', routeCategory: 'widgetFilter', type: 'late', routerValue: 'long_haul', routerActive: true },
  { id: 3, title: 'Very Late', column: 'veryLate', valueClass: 'text-red', routeCategory: 'widgetFilter', type: 'very_late', routerValue: 'long_haul', routerActive: true },
];

export const deliveryVsEtaShortHaul = [
  { id: 0, title: 'Early', column: 'early', valueClass: 'text-green-light', routeCategory: 'widgetFilter', type: 'early', routerValue: 'short_haul', routerActive: true },
  { id: 1, title: 'On time', column: 'onTime', valueClass: 'text-blue-dark', routeCategory: 'widgetFilter', type: 'on_time', routerValue: 'short_haul', routerActive: true },
  { id: 2, title: 'Late', column: 'late', valueClass: 'text-orange', class: 'border-0', routeCategory: 'widgetFilter', type: 'late', routerValue: 'short_haul', routerActive: true },
  { id: 3, title: 'Very Late', column: 'veryLate', valueClass: 'text-red', routeCategory: 'widgetFilter', type: 'very_late', routerValue: 'short_haul', routerActive: true },
];

export const autoCompleteTripCountHeaders = [
  { id: 0, title: 'Consent N/A', column: 'consent_not_available', valueClass: 'text-blue-dark', routeCategory: 'widgetFilter', type: 'consent_not_available', routerValue: 'auto_complete', routerActive: true },
  { id: 1, title: 'Location N/A', column: 'location_not_available', valueClass: 'text-orange', routeCategory: 'widgetFilter', type: 'location_not_available', routerValue: 'auto_complete', routerActive: true },
  { id: 2, title: 'Partial Location', column: 'partial_location', valueClass: 'text-red', routeCategory: 'widgetFilter', type: 'partial_location', routerValue: 'auto_complete', routerActive: true },
  { id: 3, title: 'Partial GeoFence', column: 'partial_geo_fence', valueClass: 'text-red', class: 'el-col-12 border-0', routeCategory: 'widgetFilter', type: 'partial_geo_fence', routerValue: 'auto_complete', routerActive: true },
  { id: 4, title: 'Auto Complete Days Reached', column: 'auto_complete', valueClass: 'text-green-light', class: 'el-col-12', routeCategory: 'widgetFilter', type: 'auto_complete', routerValue: 'auto_complete', routerActive: true },
];

export const tripHaltDurationHeaders = [
  { id: 0, valueClass: 'text-blue-dark', routeCategory: 'widgetFilter', routerValue: 'trip_halt_duration', routerActive: true },
  { id: 1, valueClass: 'text-orange', routeCategory: 'widgetFilter', routerValue: 'trip_halt_duration', routerActive: true },
  { id: 2, valueClass: 'text-red', routeCategory: 'widgetFilter', routerValue: 'trip_halt_duration', routerActive: true },
  { id: 3, valueClass: 'text-red', class: 'el-col-12 border-0', routeCategory: 'widgetFilter', routerValue: 'trip_halt_duration', routerActive: true },
  { id: 4, valueClass: 'text-green-light', class: 'el-col-12', routeCategory: 'widgetFilter', routerValue: 'trip_halt_duration', routerActive: true },
];

